import type { GameState } from '../types/game-state';
import { getTotalPopulation } from './world-data';
import { getReadyWeapons } from './arsenal';

function checkGameOver(state: GameState): boolean {
  // Max rounds reached
  if (state.currentRound > state.maxRounds) return true;

  // Both sides depleted
  const usReady = getReadyWeapons(state.usArsenal).length;
  const ussrReady = getReadyWeapons(state.ussrArsenal).length;
  if (usReady === 0 && ussrReady === 0) return true;

  // Population threshold (extinction)
  const usPop = getTotalPopulation(state.world.usCities);
  const ussrPop = getTotalPopulation(state.world.ussrCities);
  const originalUsPop = state.world.usCities.reduce((s, c) => s + c.population, 0);
  const originalUssrPop = state.world.ussrCities.reduce((s, c) => s + c.population, 0);

  if (usPop < originalUsPop * 0.1 && ussrPop < originalUssrPop * 0.1) return true;

  return false;
}

export { checkGameOver };
